import apiClient from "../../../utilities/apiClient";

export const addLocationMaster = (payload) => {
  return apiClient.post(`${apiClient.Urls.location_master}`, payload, true);
};

export const getLocationMasters = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.location_master}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const uploadLocationMasterExcel = (formData) => {
  return apiClient.post(
    `${apiClient.Urls.location_master_upload}`,
    formData,
    true,
    "file"
  );
};

export const downloadLocationMasterSample = () => {
  return apiClient.get(
    `${apiClient.Urls.location_master_sample}`,
    {},
    true,
    "file"
  );
};
